/**
 * EDM / GİB ham hata metinlerini personel diline çevirir (UI).
 */

const RULES = [
  {
    test: /uyuşmuyor|uyusmuyor|vergi kimlik numarası.*oturum/i,
    message:
      'Gönderen firma VKN/TCKN’si EDM hesabındaki firma ile uyuşmuyor. Faturalar → Ayarlar’da test için EDM’deki vergi numarasını kullanın; canlıda kendi firmanızı yazın.'
  },
  {
    test: /cac:Person|schemeID.*TCKN|Person elemanı/i,
    message:
      'Şahıs (TCKN) müşteri veya satıcıda ad-soyad bilgisi eksik. Müşteri adını kontrol edip kaydedin, sonra tekrar gönderin.'
  },
  {
    test: /undeclared prefix|'ext'|xmlns:ext/i,
    message: 'Fatura XML yapısı eksik (uzantı alanı). Sistem güncellemesi gerekir; tekrar deneyin veya destek alın.'
  },
  {
    test: /invalid child element 'TaxTotal'|InvoiceLine.*TaxTotal|SubInvoiceLine/i,
    message: 'Fatura satır sıralaması hatalıydı. Güncelleme sonrası tekrar GİB’e Gönder’i deneyin.'
  },
  {
    test: /Schema hatası|Schematron|Ubl yapısı hatalı|Ubl içeriği hatalı|şema kontrolünde/i,
    message: 'Fatura içeriği GİB kurallarına uymuyor. Müşteri bilgileri, tutar ve satırları kontrol edip tekrar gönderin.'
  },
  {
    test: /fatura bulunamadı|kriterine uyan fatura/i,
    message:
      'EDM’de bu referansla fatura bulunamadı. Yanlış fatura numarası kayıtlı olabilir — biraz bekleyip Yenile’yi tekrar deneyin veya Giden listesinden doğru kaydı açın.'
  },
  {
    test: /EDM_CREDENTIALS_MISSING|kullanıcı\/şifre|bağlantı bilgileri sunucuda/i,
    message: 'EDM kullanıcı bilgileri sunucuda tanımlı değil. Yöneticiye bildirin.'
  },
  {
    test: /GB_ALIAS_MISSING|GB alias bulunamadı|gönderici GB/i,
    message:
      'Canlı gönderim için EDM’de firma GB (Gönderici Birimi) alias’ı bulunamadı. EDM panelinden GİB kutunuzu kontrol edin.'
  },
  {
    test: /EDM_LIVE_BLOCKED|Canlı EDM kapalı|Canlı GİB gönderimi henüz/i,
    message: 'Canlı GİB gönderimi kapalı. Şu an yalnızca test ortamı açık.'
  },
  {
    test: /NOT_READY|onaylanmış|yalnızca onaylanmış/i,
    message: 'Önce faturayı Onaya Gönder ile onaylayın; sonra GİB’e gönderebilirsiniz.'
  },
  {
    test: /CUSTOMER|Müşteri VKN\/TCKN eksik/i,
    message: 'Müşteri TCKN/VKN eksik veya hatalı. Bilgi Eksik sekmesinden tamamlayın.'
  },
  {
    test: /SETTINGS|firma VKN\/TCKN eksik/i,
    message: 'Ayarlar’da firma vergi numarası eksik. Yönetici Faturalar → Ayarlar’dan doldurmalı.'
  },
  {
    test: /AML_HOLD|Risk kontrolü nedeniyle/i,
    message: 'Risk kontrolü nedeniyle gönderim bekletildi. Risk Kontrolü ekranından inceleyin.'
  },
  {
    test: /PACKAGE\s*-\s*PROCESSING|PROCESSING/i,
    message: 'Fatura EDM’de işleniyor. Birkaç dakika sonra Yenile ile durumu kontrol edin.'
  },
  {
    test: /SEND\s*-\s*SUCCEED|SUCCEED/i,
    message: 'Gönderim başarılı.'
  },
  {
    test: /girişi başarısız|Login/i,
    message: 'EDM girişi başarısız. Kullanıcı/şifre veya test ortamını kontrol edin.'
  },
  {
    test: /ulaşılamadı|EDM HTTP|servis hatası/i,
    message: 'EDM servisine şu an ulaşılamıyor. İnterneti kontrol edip biraz sonra tekrar deneyin.'
  }
];

const stripHtmlNoise = (raw) =>
  String(raw || '')
    .replace(/&#xD;/gi, ' ')
    .replace(/&lt;br\s*\/?&gt;/gi, ' ')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export function toFriendlyEdmMessage(raw) {
  const text = stripHtmlNoise(raw);
  if (!text) return 'İşlem başarısız. Tekrar deneyin.';
  for (const rule of RULES) {
    if (rule.test.test(text)) return rule.message;
  }
  if (text.length > 180) {
    return `EDM/GİB uyarısı: ${text.slice(0, 160)}…`;
  }
  return text;
}
